import React from 'react';
import AFlex from 'antd-mobile/lib/flex';



export default class Flex extends AFlex {}